import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/app/admin/sets/$setId")({
  component: RouteComponent,
});

function RouteComponent() {
  return <Outlet />;
}
